import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  OnDestroy,
} from "@angular/core";
import { PortfolioModel } from "../../../../shared/models/portfolio.model";
import { PortfolioService } from "../../../portfolio/portfolio.service";
import { PortfolioSelectorDialogComponent } from "../../portfolio-selector-dialog/portfolio-selector-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "src/app/shared/services/auth.service";
import { Router } from "@angular/router";
import { NavigationStateService } from "../../../../shared/services/navigation-state.service";
import { Subscription } from "rxjs";
import { MaterialModule } from "src/app/app.materials";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-nav-list",
  templateUrl: "./nav-list.component.html",
  styleUrls: ["./nav-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, RouterModule],
  standalone: true,
})
export class NavListComponent implements OnInit, OnDestroy {
  @Input() portfolio = new PortfolioModel({});
  @Input() isAdmin = false;
  @Output() closeSidenav = new EventEmitter();
  @Input() isPortfolio = false;

  active = "settings-section-optimized";
  isRiskAnalysisDisabled = false;
  private navigationStateSubscription: Subscription;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private portfolioService: PortfolioService,
    private router: Router,
    private navigationStateService: NavigationStateService,
  ) {}

  ngOnInit(): void {
    // Subscribe to navigation state changes
    this.navigationStateSubscription =
      this.navigationStateService.riskAnalysisDisabled$.subscribe(
        (disabled) => {
          this.isRiskAnalysisDisabled = disabled;
        },
      );
  }

  ngOnDestroy(): void {
    if (this.navigationStateSubscription) {
      this.navigationStateSubscription.unsubscribe();
    }
  }

  onPortfolioSelectClick() {
    this.dialog.open(PortfolioSelectorDialogComponent, {
      minWidth: "800px",
    });
  }

  onCloseSidenav() {
    this.closeSidenav.emit();
  }

  onClosePortfolio() {
    this.portfolioService.clear();
    this.router.navigate(["/app"]);
  }
  onLogout() {
    this.authService.logout(true);
  }

  scroll(el: string) {
    const element = document.getElementById(el);
    this.active = el;
    element.scrollIntoView({ behavior: "smooth" });
  }
}
